import { useCallback, useEffect, useState } from "react";
import { useSearchQueryParams } from "hooks/useSearchQueryParams";
import { useShowSnackbar } from "hooks/useShowSnackbar";
import { useNavigate } from "hooks/useCustomNavigation";
import { INTERNAL_PATHS } from "routes/paths";
import { GLOBAL_QUERY_PARAMS } from "constants/queryParams";
import { setDisplayNotification } from "services/storage";
import { CHANGE_PASSWORD_MESSAGES } from "./constants";
import { validateResetToken } from "./requests";
import { SNACKBAR_NOTIFICATION_KEYS } from "constants/notifications";

export const useCanChangePassword = () => {
  const [isLoading, setIsLoading] = useState(true);
  const queryParams = useSearchQueryParams();
  const navigate = useNavigate();
  const { addPersistedNotification } = useShowSnackbar();

  const handleInvalidResetPasswordToken = useCallback(() => {
    setDisplayNotification();
    addPersistedNotification({
      message: CHANGE_PASSWORD_MESSAGES.INVALID_TOKEN,
      variant: "error",
      persist: true,
      key: SNACKBAR_NOTIFICATION_KEYS.USED_RESET_TOKEN
    });
    navigate(INTERNAL_PATHS.RESET_PASSWORD);
  }, [addPersistedNotification, navigate]);

  const validateChangePassword = useCallback(async () => {
    const resetPasswordTokenFromQueryParam = queryParams.get(
      GLOBAL_QUERY_PARAMS.RESET_PASSWORD_TOKEN
    );
    if (!resetPasswordTokenFromQueryParam) {
      handleInvalidResetPasswordToken();
      return;
    }
    try {
      await validateResetToken({
        resetToken: resetPasswordTokenFromQueryParam
      });
      setIsLoading(false);
    } catch (error) {
      handleInvalidResetPasswordToken();
    }
  }, [queryParams, handleInvalidResetPasswordToken]);

  useEffect(() => {
    void validateChangePassword();
  }, [validateChangePassword]);

  return {
    isLoading
  };
};
